import { withWidth } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import MenuBarRight from './MenuBarRight.style';

export default withRouter(
  compose(withWidth())(withTranslation()(MenuBarRight))
);
